import { useMutation } from '@tanstack/react-query';
import axios from '../../../../common/api/request';

interface ForecastAnalysisRequest {
  type: 'html' | 'xls';
  stratumSizesCalculated?: boolean;
}

interface ForecastAnalysisResponse {
  postData: any;
  getData: any;
}

interface ForecastAnalysisMutationOptions {
  onSuccess?: (data: ForecastAnalysisResponse) => void;
  onError?: (error: any) => void;
}

export function useForecastAnalysis(options?: ForecastAnalysisMutationOptions) {
  return useMutation({
    mutationFn: async (data: ForecastAnalysisRequest): Promise<ForecastAnalysisResponse> => {
      let postResponse = null;
      
      // Only make POST request if stratum sizes haven't been calculated yet
      if (!data.stratumSizesCalculated) {
        postResponse = await axios.post('/forecast-stratum', { type: data.type });
      }
      
      // Always make the GET request
      const getResponse = await axios.get('/forecast-stratum');
      
      return {
        postData: postResponse?.data || null,
        getData: getResponse.data
      };
    },
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(error);
    },
  });
}

export type { ForecastAnalysisRequest }; 